var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloperApi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xml 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7416 2.5L12.375 2.83333L9.25832 17.5L7.62498 17.1667L10.7416 2.5ZM16.325 10L13.3333 7.00833V4.65L18.6833 10L13.3333 15.3417V12.9833L16.325 10ZM1.31665 10L6.66665 4.65V7.00833L3.67498 10L6.66665 12.9833V15.3417L1.31665 10Z",
    fill: "#66D1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperApi);
export default __webpack_public_path__ + "static/media/developer-api.1e93140f31309d5eb365f8e33dd5e1d0.svg";
export { ForwardRef as ReactComponent };